module.exports = __webpack_public_path__ + "img/20190919160006296.8c18736c.jpg";